import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-solution1',
  templateUrl: './solution1.component.html',
  styleUrls: ['./solution1.component.scss']
})
export class Solution1Component implements OnInit {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'Budget Insights: Variance Analysis & Scenario Planning',
      description: 'Monitor budget performance, analyse variances and model scenarios with DotBlack’s web-based Budget Insights application.',
      path: '/products/solution1/',
      type: 'product',
      schema: { '@context': 'https://schema.org', '@type': 'Product', name: 'Budget Insights', brand: { '@type': 'Brand', name: 'DotBlack' }, url: 'https://dotblack.co.za/products/solution1/', description: 'Monitor budget performance, analyse variances and model scenarios with DotBlack’s web-based Budget Insights application.' }
    });
  }
}
